module.exports = __webpack_public_path__ + "04b6522544c925f6204ab911ec123570.svg";